import { Tooltip } from 'primereact/tooltip';
import type { HistoricoItem } from '../../../../services/notificacoes';
import { CLASSIFICACAO_META, type ClassificacaoKey } from '../alertas-utils';

const buildRedirectUrl = (item: HistoricoItem, propriedadeId: number) => {
  const date = item.createdAt.substring(0, 10);
  return `/#!/propriedade?operacao=${item.tipo}&date=${date}&gleba=${item.gleba.id}&propriedade=${propriedadeId}`;
};

const NotificacaoRow = ({
  item,
  propriedadeId,
}: {
  item: HistoricoItem;
  propriedadeId: number;
}) => {
  const meta =
    CLASSIFICACAO_META[item.situacao as ClassificacaoKey] ??
    CLASSIFICACAO_META.neutro;
  const badgeId = `notif-badge-${item.id}`;
  const redirectUrl = buildRedirectUrl(item, propriedadeId);

  return (
    <tr className="notificacao-item">
      <td className="notificacao-gleba">{item.gleba.descricao}</td>
      <td className="notificacao-badge-cell">
        <a
          id={badgeId}
          href={redirectUrl}
          className="notificacao-tipo-badge notificacao-tipo-badge--link"
          style={{ backgroundColor: meta.bgColor, color: meta.textColor }}
        >
          {item.tipoToPtBr}
        </a>
        {item.hint && (
          <Tooltip
            target={`#${badgeId}`}
            content={item.hint}
            appendTo={document.body}
            position="left"
            className="notificacao-hint-tooltip"
          />
        )}
      </td>
      <td className="notificacao-meta">{item.tempoDecorrido}</td>
    </tr>
  );
};

export default NotificacaoRow;
